import { Snackbar } from "@material-ui/core";
import { Alert } from "react-bootstrap";
import UtilsFormule from "../../../../../utils/UtilsFormule";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WorkstationService from "../../../../../services/Production/WorkstationService";
import getCurrentUserId from "../../../../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../../../../components/layouts/WithLoader";

const WorkstationList = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [availableWorkstation, setAvailableWorkstation] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const onAddWorkStationHandler = () => {
    navigate(`/workstations/new`);
  };

  useEffect(() => {
    startLoading();
    WorkstationService.allWorkstations(getCurrentUserId())
      .then((response) => {
        console.log("response", response);
        if (response.data.success) {
          setAvailableWorkstation(response.data.success);
        } else {
          setOpenErrorAlert(true);
          // setErrorAlertText("Erreur : pas de station de travail");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const onViewProductsHandler = (warehouseId, warehouseName) => {
    sessionStorage.setItem("idWarehouse", warehouseId);
    sessionStorage.setItem("typeDocument", "Warehouse");
    // navigate("/warehouseProducts");
    window.open("/warehouseProducts", "_blank");
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les stations de travail</h5>
                  <button
                    class="btn btn-dark float-right"
                    data-toggle="modal"
                    data-target="#add-brand"
                    onClick={onAddWorkStationHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
              <section class="content">
                <div class="card">
                  <div class="card-header  ">
                    <h3 class="card-title">Les stations de travail</h3>
                    <div class="card-tools">
                      <button
                        type="button"
                        class="btn btn-tool"
                        data-card-widget="collapse"
                        title="Collapse"
                      >
                        <i class="fas fa-minus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="card-body p-0">
                    <table class="table  projects">
                      <thead>
                        <tr>
                          <th>Libellé</th>
                          <th>Capacité</th>
                          <th>Dépôt d'entré</th>
                          <th>Dépôt de sortie</th>

                          <th style={{ width: "12%" }}>DC</th>
                          {/* <th className="text-center" style={{ width: "12%" }}>
                                                        Modifier
                                                    </th> */}
                          <th className="text-center" style={{ width: "12%" }}>
                            Voir Plus
                          </th>

                          <th className="text-center" style={{ width: "12%" }}>
                            Les Operations
                          </th>
                          {/* <th className="text-center" style={{ width: "12%" }}>
                                                        Archiver
                                                    </th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {availableWorkstation &&
                          availableWorkstation.map((element, i) => (
                            <tr key={element.id}>
                              <td>
                                {element.code}-{element.name}
                              </td>
                              <td>{element.capacity}</td>
                              <td>
                                {" "}
                                <button
                                  class="btn bg-light btn-sm "
                                  onClick={() =>
                                    onViewProductsHandler(
                                      element.warehouseEntreeId,
                                      element.warehouseEntreeName
                                    )
                                  }
                                >
                                  {element.warehouseEntreeName}
                                </button>
                              </td>
                              <td>
                                <button
                                  class="btn bg-light btn-sm "
                                  onClick={() =>
                                    onViewProductsHandler(
                                      element.warehouseSortieId,
                                      element.warehouseSortieName
                                    )
                                  }
                                >
                                  {element.warehouseSortieName}
                                </button>
                              </td>
                              <td>
                                {UtilsFormule.formatDate(element.dateCreation)}
                              </td>
                              <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn btn-dark btn-sm"
                                  onClick={() => {
                                    sessionStorage.setItem(
                                      "idWorkstation",
                                      element.id
                                    );
                                    navigate(`/workstationsDetails`);
                                  }}
                                >
                                  <i class="fas fa-folder"></i>
                                </button>
                              </td>
                              <td className="text-center">
                                <button
                                  style={{ width: 40 }}
                                  class="btn btn-dark btn-sm"
                                  onClick={() => {
                                    sessionStorage.setItem(
                                      "idWorkstation",
                                      element.id
                                    );
                                    navigate(`/workstationsOperations`);
                                  }}
                                >
                                  <i class="fas fa-folder"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(WorkstationList);
